import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import { inject } from "mobx-react";
import { replaceStaticHost } from "Helpers/ImageManager";
import { sendMetriks } from "Services/sendMetriks";
import userInfo from "Services/UserInfo";
import useCurrentRegion from "Services/useCurrentRegion";
import { Contacts, FormLayout, InputCheckbox, Logo, TariffInfoV2, Title } from "Layouts/TariffFormLayout";
import { Form, FormError } from "Layouts/Form";
import PhoneContainerProvider from "Containers/PhoneContainerProvider";
import { TextField } from "ComponentsUI/TextField";
import Button from "ComponentsUI/Button";
import { Col } from "ComponentsUI/Styles/Grid";
import TermsOfUse from "ComponentsUI/TermsOfUse";
import { CLICK_SEND_ORDER_WITH_TARIFF } from "Constants/metriks/Yandex";

function TariffFormContainer(props) {
    const regionData = useCurrentRegion();
    const [fio, setFio] = useState("");
    const [phoneConnection, setPhone] = useState("");

    const [isError, setError] = useState(false);
    const [isSuccess, setSuccess] = useState(false);
    let providerInfo = props.providerInfo
    const { provider } = props.tariff;
    const { contacts } = provider;
    let region = null;
    let text = props.text;
    let windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;
    if (!regionData.loading) {
        region = regionData.data.region;
    }

    const onChangePhoneHandler = e => {
        setPhone(e.target.value);
    };

    const onBlurPhone = () => {
        setError(phoneConnection.length !== 11 && phoneConnection.length !== 1);
    };

    const onFocusPhone = () => {
        setError(false);
    };

    const onClickConnectHandler = e => {
        if (!props.validatePhone(phoneConnection)) {
            setError(true);
            return null;
        } else {
            setSuccess(true);
            sendMetriks("SEND_CONNECT_TARIFF")
            let data = {
                fio: "",
                phone_connection: phoneConnection,
                provider_id: provider.id,
                tariff_id: props.tariff.id,
                region_id: region.id,
                lead_form_type: userInfo(
                    CLICK_SEND_ORDER_WITH_TARIFF,
                    "connect_tariff"
                ),
            };

            props.sendOrder(data).then(dataPromise => {
                if (!dataPromise) {
                    props.sendOrderRepeat(data);
                }
            });
        }
    };

    let phone = "";

    if (provider) {
        if (provider.hasOwnProperty("contacts")) {
            if (provider.contacts.hasOwnProperty("phones")) {
                phone = contacts.phones.length && contacts.phones[0];
            }
        }
    } else if (providerInfo) {
        if (providerInfo.hasOwnProperty("contacts")) {
            if (providerInfo.contacts.hasOwnProperty("phones")) {
                phone = providerInfo.contacts.phones.length && providerInfo.contacts.phones[0];
            }
        }
    }
    let successButton = (
        <Button
            status={"secondaryAccent"}
            transparent={true}
            datatest={"give_feedback"}
            onClick={props.closeModal}
        >
            {text.WELCOME_CB_WIDGET_TITLE}
        </Button>
    );

    return (
        <FormLayout>
            <Form
                type={"popupForm"}
                isSuccess={isSuccess}
                successHeader={
                    <>
                        <div>{text.ORDER_SUCCESS_0}</div>
                        <div>{text.ORDER_SUCCESS_4}</div>
                        <div>{text.ORDER_SUCCESS_5}</div>
                    </>
                }
                successButton={successButton}
            >
                {!!provider.vip_provider && (
                    <TariffInfoV2
                        tariff={props.tariff}
                        provider={provider}
                        text={text}
                        phone={phone}
                    />
                )}
                <TextField
                    autocomplete="tel"
                    name="tel"
                    onChange={e => {
                        onChangePhoneHandler(e);
                    }}
                    onEnter={() => {
                        onClickConnectHandler();
                    }}
                    label={text.ORDER_PHONE_PLACEHOLDER}
                    placeholder={"+7"}
                    datatest="popup_tariff_order_input_tel"
                    inputBackgroundColor={"transparent"}
                    type={"phone"}
                    size={"medium"}
                    onBlur={() => onBlurPhone()}
                    onFocus={() => onFocusPhone()}
                    autoFocus={!windowSizes.xs && !windowSizes.sm}
                    isError={isError}
                />
                <FormError
                    show={isError}
                    hidden={!isError}
                    datatest={"popup_tariff_order_incorrect_data"}
                    tariffFormContainer={true}
                >
                    {text.SEND_ORDER_ERROR_1}
                </FormError>
                <Button
                    status={"secondaryAccent"}
                    datatest="popup_tariff_order_form_input_connect_button"
                    onClick={() => {
                        onClickConnectHandler();
                    }}
                    fullWidth={true}
                >
                    {text.SEND_ORDER}
                </Button>
                <TermsOfUse
                    buttonText={text.SEND_ORDER}
                    isTariffOrderPopup={true}
                    textAlignCenter={true}
                />
            </Form>
            {/*{!!props.providerInfo && (
                <Col
                    xsHidden
                    mdHidden
                    lgHidden
                    style={{ paddingRight: "55px" }}
                >
                    <InfoBlock>
                        <Logo>
                            <img
                                alt={"logo"}
                                src={replaceStaticHost(provider.logo)}
                            />
                        </Logo>
                        <Contacts>
                            <div>{text.PHONE}</div>
                            <div>
                                {contacts.card == 3 ? (
                                    <a href={contacts.link} target="_blank">
                                        {text.show_phone}
                                    </a>
                                ) : (
                                    <PhoneContainerProvider phone={phone} />
                                )}
                            </div>
                        </Contacts>
                        {!isSuccess && (
                            <Title>
                                <span>{text.ORDER_CONNECT_TO_PROVIDER} </span>
                                <span className={"bold"}>{provider.name}</span>
                                <span>{` ${text.ON_OUR_SITE}`}</span>
                            </Title>
                        )}
                    </InfoBlock>
                </Col>
            )}
            {!!props.providerInfo && (
                <Col
                    smHidden
                    style={{
                        padding: 0,
                        flexBasis: "auto",
                        textAlign: "center",
                    }}
                >
                    <Logo>
                        <img
                            alt={"logo"}
                            src={replaceStaticHost(provider.logo)}
                        />
                    </Logo>
                </Col>
            )}
            {!!props.providerInfo && (
                <Col smHidden style={{ padding: 0, flexBasis: "auto" }}>
                    <Contacts>
                        <div>{text.PHONE}</div>
                        <div>
                            {contacts.card == 3 ? (
                                <a
                                    href={contacts.link}
                                    style={{ borderBottom: "1px dashed" }}
                                    target="_blank"
                                >
                                    {text.show_phone}
                                </a>
                            ) : (
                                <PhoneContainerProvider phone={phone} />
                            )}
                        </div>
                    </Contacts>
                </Col>
            )}
            <Form
                type={"tariffForm"}
                isSuccess={isSuccess}
                successHeader={
                    <>
                        <div>{text.ORDER_SUCCESS_0}</div>
                        <div>{text.ORDER_SUCCESS_4}</div>
                        <div>{text.ORDER_SUCCESS_5}</div>
                    </>
                }
                successButton={successButton}
            >
                {!!props.providerInfo && (
                    <Col smHidden style={{ padding: 0, flexBasis: "auto" }}>
                        {!isSuccess && (
                            <Title>
                                <span>{text.ORDER_CONNECT_TO_PROVIDER} </span>
                                <span className={"bold"}>{provider.name}</span>
                                <span>{` ${text.ON_OUR_SITE}`}</span>
                            </Title>
                        )}
                    </Col>
                )}
                <TextField
                    autocomplete="name"
                    name="name"
                    onChange={e => {
                        onChangeFioHandler(e);
                    }}
                    onEnter={() => {
                        onClickConnectHandler();
                    }}
                    label={text.ORDER_NAME_PLACEHOLDER}
                    datatest="providers_provider_order_input_name"
                    inputBackgroundColor={"transparent"}
                    size={"medium"}
                    autoFocus={!windowSizes.xs && !windowSizes.sm}
                />
                <TextField
                    autocomplete="tel"
                    name="tel"
                    onChange={e => {
                        onChangePhoneHandler(e);
                    }}
                    onEnter={() => {
                        onClickConnectHandler();
                    }}
                    label={text.ORDER_PHONE_PLACEHOLDER}
                    placeholder={"+7"}
                    datatest="providers_provider_order_input_tel"
                    inputBackgroundColor={"transparent"}
                    type={"phone"}
                    size={"medium"}
                    onBlur={onBlurPhone}
                    onFocus={onFocusPhone}
                />
                <FormError
                    show={isError}
                    hidden={!isError}
                    tariffForm
                    datatest={"incorrect_data"}
                >
                    {text.SEND_ORDER_ERROR}
                </FormError>
                <Button
                    status={"secondaryAccent"}
                    fullWidth={true}
                    datatest="order_form_input_connect_button"
                    onClick={onClickConnectHandler}
                >
                    {text.SEND_ORDER}
                </Button>
                {!props.providerInfo && (
                    <TermsOfUse
                        buttonText={text.SEND_ORDER}
                        isPopupOperator={true}
                    />
                )}
            </Form>*/}
        </FormLayout>
    );
}

export default inject("ApplicationModel")(TariffFormContainer);
